import { useQuery } from '@apollo/client'
import Image from 'next/legacy/image'
import PropTypes from 'prop-types'

import { Text, Loading, Link, MarkdownContainer } from '@components'

import styles from './style.module.css'

import { getFeaturedArticles } from '@gql/blogQuery'

function FeaturedArticle({ category }) {
  const { loading, data: { articles = [] } = {} } = useQuery(
    getFeaturedArticles,
    {
      variables: { category },
    }
  )

  const featuredArticle = articles[0]

  return (
    <div className={styles.container}>
      {loading && !featuredArticle ? (
        <Loading />
      ) : (
        <>
          <div className={styles.featuredImage}>
            <Link link={`/blog/${featuredArticle.titleSlug}`}>
              <Image
                alt="featured article"
                src={featuredArticle.image}
                layout="responsive"
                height={640}
                width={1024}
                priority
              />
            </Link>
          </div>

          <Text tag="h4" variant="sectionTitle" className={styles.featuredText}>
            FEATURED
          </Text>

          <Text tag="h3" variant="articleTitle" className={styles.articleTitle}>
            <Link link={`/blog/${featuredArticle.titleSlug}`}>
              {featuredArticle.title}
            </Link>
          </Text>

          <MarkdownContainer
            content={featuredArticle.content}
            isSmallParagraph
            parseOnlyFirstParagraph
          />
        </>
      )}
    </div>
  )
}

FeaturedArticle.propTypes = {
  category: PropTypes.string,
}

export default FeaturedArticle
